/**
 * Subrol del usuario: solo políticas (límites dentro del mismo rol base).
 * El menú y acceso a módulos sigue el `user_role` (admin, broker…); movil y web no dependen de listas de permisos.
 *
 * API getUserById: `subrole_id` + `subrole` (objeto con `policies`, etc.).
 * Nota: el subrol se mantiene solo en memoria (Vuex), sin persistir en localStorage.
 */

function normalizeSubroleFromUser(user) {
  if (!user || !user.subrole) return null;

  return {
    subroleId: String(user.subrole_id),
    subroleName: user.subrole.name || "",
    policies:
      user.subrole.policies && typeof user.subrole.policies === "object"
        ? JSON.parse(JSON.stringify(user.subrole.policies))
        : {}
  };
}

export default {
  namespaced: true,

  state: {
    subroleId: null,
    subroleName: "",
    policies: {}
  },

  getters: {
    /** Tiene subrol asignado (refinar comportamiento con políticas) */
    hasSubrole: state => Boolean(state.subroleId),

    subroleId: state => state.subroleId,
    subroleName: state => state.subroleName,
    policiesObject: state => state.policies,

    getPolicy: state => (namespace, key) => {
      const ns = state.policies[namespace];
      if (!ns || typeof ns !== "object") return undefined;
      return ns[key];
    },

    getPoliciesForModule: state => namespace =>
      state.policies[namespace] && typeof state.policies[namespace] === "object"
        ? state.policies[namespace]
        : null
  },

  mutations: {
    setSubrole(state, { subroleId, subroleName, policies }) {
      state.subroleId = subroleId || null;
      state.subroleName = subroleName || "";
      state.policies = policies && typeof policies === "object" ? policies : {};
    },

    clear(state) {
      state.subroleId = null;
      state.subroleName = "";
      state.policies = {};
    }
  },

  actions: {
    hydrateFromUser({ commit }, user) {
      const normalized = normalizeSubroleFromUser(user);
      if (!normalized) {
        commit("clear");
        return;
      }
      commit("setSubrole", normalized);
    }
  }
};
